import { Injectable } from '@angular/core';
import {of} from 'rxjs';
import {AccountsApiService} from "../api/accounts-api.service";
import {Account} from "../auth/auth.model";

@Injectable({
  providedIn: 'root'
})
export class ChangeAccountService {
  accounts: Account[] = [];

  constructor(private accountsApi: AccountsApiService) {
    // load accounts depending on client group match
    this.accountsApi.getGroupAccounts().subscribe(data => {
      this.accounts = data;
    });
  }

  searchingValue(value) {
    return of(this.accounts.filter(account => account.customerNumber.replace(/[\s]/g,'').toLowerCase().indexOf(value.toLowerCase()) === 0 ));
  }

  getAccounts() {
    return this.accounts;
  }

  isGroupAccount() {
    return this.accountsApi.isGroupAccount();
  }
}
